import { memo, type JSX } from 'react';
import styled, { keyframes } from 'styled-components';

type Props = {
  txt?: string;
  children?: JSX.Element | JSX.Element[];
};

const marqueeAnim = keyframes`
  0% {
    transform: translateX(110%);
  }

  100% {
    transform: translateX(-62%);
  }
`;

const SiteMarqueeStyled = styled.div`
  overflow: hidden;
  display: block;
`;

const SiteMarqueeContainer = styled.div`
  position: relative;
  overflow: visible;
  display: block;
`;

const SiteMarqueeAnim = styled.div`
  transition: all 0.25s ease;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${marqueeAnim} 20s linear infinite;
  }
  transform: translateX(110%);
  position: relative;
  white-space: nowrap;
  line-height: 60px;
`;

const SiteMarquee = memo(({ txt, children }: Props) => (
  <SiteMarqueeStyled className='site-marquee'>
    <SiteMarqueeContainer className='site-marquee-container'>
      <SiteMarqueeAnim className='site-marquee-anim'>
        {txt || children}
      </SiteMarqueeAnim>
    </SiteMarqueeContainer>
  </SiteMarqueeStyled>
));

export default SiteMarquee;
